<template>
  <div class="employee-issue-building-report">
    <div class="employee-issue-building-report__row">
      <div class="employee-issue-building-report__chart-column employee-issue-building-report__chart-column_pie">
        <e-charts :options="pie" ref="pie" auto-resize theme="ovilia-green"/>
      </div>
      <div class="employee-issue-building-report__chart-column employee-issue-building-report__chart-column_line">
        <e-charts :options="line" ref="line" auto-resize theme="ovilia-green" width="100%"/>
      </div>
    </div>
  </div>

</template>

<script>
  import ECharts from 'vue-echarts/components/ECharts'
  import 'echarts/lib/component/tooltip'
  import 'echarts/lib/component/legend'
  import 'echarts/lib/chart/line'
  import 'echarts/lib/chart/pie'
  import theme from '@/assets/echarts-themes/tasks-report-charts';
  ECharts.registerTheme('ovilia-green', theme);
  export default {
    name: "BuildingsAnalytics",
    components: {
      ECharts,
    },
    props: {
      period: {},
      buildings: {}
    },
    data(){
      return {
        info: {},
      }
    },
    computed: {
      CHART_LEGENDS(){
        return this.$store.getters['common/tasks/statuses'];
      },
      dateList(){
        let dateStart = this.$moment(this.period.from);
        let dateEnd = this.$moment(this.period.to);
        let list = [];
        while (dateEnd >= dateStart) {
          list.push(dateStart.format('DD.MM.YYYY'));
          dateStart.add(1, 'day');
        }
        return list;
      },
      valueDoneList(){
        return this.getValuesByStatus(this.CHART_LEGENDS.done.id);
      },
      valueNewList(){
        return this.getValuesByStatus(this.CHART_LEGENDS.new.id);
      },
      valueCancelList(){
        return this.getValuesByStatus(this.CHART_LEGENDS.cancel.id);
      },
      valueInWorkList(){
        return this.getValuesByStatus(this.CHART_LEGENDS['in-work'].id);
      },
      valueDoneTotal(){
        return this.valueDoneList.reduce((a, b) => a + b, 0);
      },
      valueNewTotal(){
        return this.valueNewList.reduce((a, b) => a + b, 0);
      },
      valueCancelTotal(){
        return this.valueCancelList.reduce((a, b) => a + b, 0);
      },
      valueInWorkTotal(){
        return this.valueInWorkList.reduce((a, b) => a + b, 0);
      },
      windowWidth(){
        return this.$store.getters.windowWidth;
      },
      line() {
        let interval = 0;

        if(this.dateList.length > 100){
          interval = 20;
        }
        else if(this.dateList.length > 32){
          interval = 4;
        }
        else if(this.dateList.length > 20){
          if( this.windowWidth <= 1366){
            interval = 1;
          }
        }
        else{
          if(this.windowWidth <= 1200){
            interval = 3;
          }
        }

        return {
          visualMap: [{
            show: false,
            type: 'continuous',
            seriesIndex: 0,
            min: 0,
            max: 400
          }],
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: Object.values(this.CHART_LEGENDS).map(l => l.name)
          },
          xAxis: {
            data: this.dateList,
            axisLabel: {
              interval: interval,
              rotate: 20,
            }
          },
          yAxis: {
            splitLine: {show: false},
          },
          series: [
            {
              name: this.CHART_LEGENDS.new.name,
              legend: 'plain',
              type: 'line',
              showSymbol: false,
              data: this.valueDoneList,
              smooth: true,
              lineStyle: {color: '#59c4e6'}
            },
            {
              name: this.CHART_LEGENDS['in-work'].name,
              type: 'line',
              showSymbol: false,
              data: this.valueInWorkList,
              smooth: true,
              lineStyle: {color: '#ffb980'}
            },
            {
              name: this.CHART_LEGENDS.done.name,
              type: 'line',
              showSymbol: false,
              data: this.valueNewList,
              smooth: true,
              lineStyle: {color: '#7bd9a5'}
            },
            {
              name: this.CHART_LEGENDS.cancel.name,
              type: 'line',
              showSymbol: false,
              data: this.valueCancelList,
              smooth: true,
              lineStyle: {color: '#ea5455'}
            }
          ]
        }
      },
      pie() {
        let pieData = [
          {value: this.valueNewTotal, name: this.CHART_LEGENDS.new.name},
          {value: this.valueInWorkTotal, name: this.CHART_LEGENDS['in-work'].name},
          {value: this.valueDoneTotal, name: this.CHART_LEGENDS.done.name},
          {value: this.valueCancelTotal, name: this.CHART_LEGENDS.cancel.name},
        ];

        return {
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'center',
            top: 'bottom',
            data: Object.values(this.CHART_LEGENDS).map(l => l.name),
            formatter: function (name) {
              let itemValue = pieData.filter(item => item.name === name);
              return `${name}: ${itemValue[0].value}`
            },
          },
          series: [
            {
              type: 'pie',
              radius: '55%',
              center: ['50%', '40%'],
              color: ['#59c4e6','#ffb980','#7bd9a5','#ea5455'],
              data: pieData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      }
    },
    methods: {
      getValuesByStatus(status){
        let values = [];

        this.dateList.forEach(date => {
          let object = this.info[date] || {1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0};
          values.push(object[status]);
        });

        return values;
      },
      async updateData() {
        let params = {
          buildings_id: this.buildings,
          startDate: this.$options.filters.moment(this.period.from, 'YYYY-MM-DD'),
          endDate: this.$options.filters.moment(this.period.to, 'YYYY-MM-DD')
        };

        let {data} = await this.$http.get('tasks/report', {
          params: params
        });
        let foramattedData = {};
        for (let index in data){
          if(data.hasOwnProperty(index)){
            let date = this.$options.filters.moment(this.$parseDateFromString(index), 'DD.MM.YYYY');
            foramattedData[date] = data[index];
          }
        }
        this.info = foramattedData;
      }
    },
    mounted() {
      this.updateData();
    }
  }
</script>

<style lang="scss">
  .employee-issue-building-report {
    flex: 1;
    display: flex;

    &__row {
      display: flex;
      align-items: center;
      flex: 1;
    }

    &__chart-column {
      margin-bottom: 30px;

      &_pie {
        flex: 0 0 480px;
      }

      &_line {
        flex: 1;
        max-width: calc(100% - 480px);
      }
    }

    @media (max-width: 1200px) {
      &__row {
        display: block;
      }

      &__chart-column {
        max-width: 100%;

        &_pie,
        &_line {
          max-width: 100%;
        }
      }
    }
  }
</style>